// b76dff1dffdd73059d690f98d75e9d8dca1de0b6|className=CurrencyApi|type=angular|apiName=am|apiEnumKey=AM|operationHash=61da63f874017bc172999e0d8856cd15726b5a70|kind=api-js

import * as i0 from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Api } from '@myre/common-conf';
import {
  DynamicEnvService,
  AngularSdk,
} from '@myre/ui-domain-http';
import { parseOkResponseFromJSON } from '../../../parsers/OkResponse';

import { parseCurrencyFromJSON } from '../../../parsers/Currency';

export class CurrencyApi extends AngularSdk {
  constructor(
    dynamicEnvService,
    httpClient,
  ) {
    super(dynamicEnvService, httpClient);
  }

  /**
   * @description <p>📝 Static reference data, the same for every customer: no scope parameter and no authentication.</p>
   *
   * @tags CurrencyApi
   * @name CurrencyApiGetAllCurrencies
   * @summary Get all currencies
   * @request GET:/currencies
   */
  getAllCurrencies(
    requestOptions = {},
  ) {
    return this._request(
      {
        path: `/currencies`,
        method: 'GET',
        api: Api.AM,
      },
      {
        ...requestOptions,
        parser: data => parseOkResponseFromJSON(data, {
    contentParser: parseCurrencyFromJSON,
    isContentArray: true,
  }),
      },
    );
  }

  static ɵfac = function CurrencyApi_Factory(t) { return new (t || CurrencyApi)(i0.inject(DynamicEnvService), i0.inject(HttpClient)); };
  static ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({ token: CurrencyApi, factory: CurrencyApi.ɵfac, providedIn: 'root' });
}
